module.exports = __webpack_public_path__ + "media/images/exec-logo-24d722a4.svg";